import { getQueryParam } from "@circle-react/helpers/urlHelpers";

export const useVerificationQueryParams = () => {
  const paymentIntent = getQueryParam("payment_intent") || "";
  const paymentMethodType = getQueryParam("payment_method_type") || "";

  return {
    paymentIntent,
    paymentMethodType,
    isVerifiable: !!paymentIntent,
  };
};
